// extracted by mini-css-extract-plugin
export default {"responsesContainer":"SessionAvatarResponseDisplay_responsesContainer__U4-Ym","response":"SessionAvatarResponseDisplay_response__gZJ9p"};